export default __webpack_public_path__ + "static/media/5.c6de939a.png";